// Features
import { initialState as initialInvestmentsOverviewState } from "./features/investmentsOverview/slice"
import { initialState as initialUserPreferencesState } from "./features/userPreferencesSlice"
import { initialState as initialPaymentPatchesState } from "./features/energySupplierApproval/paymentPatchesSlice"

// Types
import { UsersUserProfileLanguageChoices } from "@/api/graphql/types"

// Values
import { ProjectSortMethod } from "./features/investmentsOverview/types"

// Export migrations
/* oxlint-disable typescript/no-unsafe-return */
export const migrations = {
	1: (state: any) => {
		return state
	},
	2: (state: any) => {
		return {
			...state,
			investmentsOverview: {
				...initialInvestmentsOverviewState,
				...state.investmentsOverview,
			},
			userPreferences: {
				...initialUserPreferencesState,
				...state.userPreferences,
			},
		}
	},
	3: (state: any) => {
		return {
			...state,
			investmentsOverview: {
				...initialInvestmentsOverviewState,
				...state.investmentsOverview,
			},
			userPreferences: {
				...initialUserPreferencesState,
				...state.userPreferences,
			},
		}
	},
	4: (state: any) => {
		return {
			...state,
			investmentsOverview: {
				...state.investmentsOverview,
				sortingMethod: ProjectSortMethod.Name,
			},
		}
	},
	5: (state: any) => {
		return {
			...state,
			investmentsOverview: {
				...state.investmentsOverview,
				showHiddenProjects: true,
			},
		}
	},
	6: (state: any) => {
		return {
			...state,
			userPreferences: {
				...state.userPreferences,
				showInvestmentBanner: true,
			},
		}
	},
	7: (state: any) => {
		return {
			...state,
			paymentPatches: {
				...initialPaymentPatchesState,
			},
		}
	},
	8: (state: any) => {
		return {
			...state,
			userPreferences: {
				...state.userPreferences,
				lang: UsersUserProfileLanguageChoices.Nl,
			},
		}
	},
	9: (state: any) => {
		const rest = { ...state }
		delete rest.auth
		return rest
	},
}
